import {
    initTracerSdk,
    initTracerError,
    initTracerErrorUploader,
} from '@apptracer/sdk';

/**
 * Паттерны сообщений ошибок, которые не отправляем в Tracer.
 * Перенесены из Sentry ignoreErrors + шум от расширений/баннеров/чанков.
 */
const IGNORE_ERROR_PATTERNS = [
    'Request has been terminated',
    'has been blocked by CORS policy',
    'invalid message received by the iframe API',
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'ChunkLoadError',
    'Loading chunk',
    'Loading CSS chunk',
    'Load failed',
];

/**
 * Паттерны URL в стектрейсе, ошибки с которых игнорируем
 * (браузерные расширения, внешние скрипты, реклама).
 */
const DENY_URL_PATTERNS = [
    /extensions\//i,
    /^chrome:\/\//i,
    /chrome-extension/i,
    /yandex/i,
    /yastatic/i,
    /ad\.mail\.ru/i,
    /ads\.vk\.com/i,
];

function isIgnoredMessage(error) {
    const message = (error && error.message) || '';

    return IGNORE_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}

function isDeniedUrl(errorInfo) {
    const stack = errorInfo && errorInfo.errorStack;

    if (!stack) {
        return false;
    }

    return DENY_URL_PATTERNS.some((pattern) => pattern.test(stack));
}

/**
 * Фильтр ошибок для Tracer. Возвращает false, если ошибку не нужно отправлять.
 */
function filterError(error, errorInfo) {
    if (isIgnoredMessage(error)) {
        return false;
    }

    if (isDeniedUrl(errorInfo)) {
        return false;
    }

    return true;
}

const TRACER_CONFIG = {
    versionName: WEBPACK_RELEASE,
    appToken: TRACER_APP_TOKEN,
    environment: WEBPACK_APP_MODE,
};

/**
 * Инициализация Tracer: сбор и отправка ошибок.
 * Ничего не делает, если appToken не задан (например, в dev-сборке).
 */
export default function initTracer() {
    console.debug('Tracer: initing…');
    if (!TRACER_APP_TOKEN) {
        return null;
    }

    console.debug('Tracer: inited');
    return initTracerSdk(
        TRACER_CONFIG,
        () => initTracerError({ filterError }),
        initTracerErrorUploader,
    );
}
